function fileSpecName(value: unknown): string | null {
  if (typeof value !== 'object' || value === null) return null
  const filename = Reflect.get(value, 'filename')
  return typeof filename === 'string' && filename ? filename : null
}

function fileSpecNames(values: readonly unknown[]): string | null {
  const names = values.map(fileSpecName).filter((name) => name !== null)
  return names.length > 0 ? names.join(', ') : null
}

export function formatSpecValue(value: unknown): string | null {
  if (value === null || value === undefined || value === '') return null
  if (typeof value === 'boolean') return value ? 'Yes' : 'No'
  if (typeof value === 'object') {
    return Array.isArray(value) ? fileSpecNames(value) : fileSpecName(value)
  }
  const str = String(value)
  return str.charAt(0).toUpperCase() + str.slice(1)
}
